// Copyright (c) Silence Laboratories Pte. Ltd.
// This software is licensed under the Silence Laboratories License Agreement.

export default function TermAndPolicy() {
  return (
    <div>
      By using the Silent Shard Snap and the companion products (Silent Shard DApp and Silent Shard
      Mobile Application), you are accepting the
      <a
        href="https://www.silencelaboratories.com/terms-of-use"
        target="_blank"
        rel="noreferrer"
        className="mx-1 text-white-primary b2-bold">
        Terms of use
      </a>
      and
      <a
        href="https://www.silencelaboratories.com/privacy"
        target="_blank"
        rel="noreferrer"
        className="mx-1 text-white-primary b2-bold">
        Privacy Policy
      </a>
    </div>
  );
}
